import { FC, useEffect, useState } from "react"
import { motion } from "framer-motion";
import { Asset } from "lib/types";
import { Box } from "@chakra-ui/layout";
import { useLoggedinUser, usePack } from "lib/hooks";
import { openLink } from "../../base/link/utils";
import { useRouter} from "next/router";
import { usePackContext } from "domains/pack";
import { isEditable } from "../../utils";
import { isPreviewingPack, getMeta } from "lib/utils";

const variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      delayChildren: 0.15,
    }
  }
};

type State = {
  height: string;
  width: string;
}

export const AssetImageLink: FC<{ asset: Asset<any> }> = ({ asset }) => {
  const [dimensions, setDimensions] = useState<State>({
    height: '0px',
    width: '0px',
  });
  const { data: user } = useLoggedinUser();
  const { pathname } = useRouter();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);

  const canEdit = isEditable(asset, user, pack) && !isPreviewingPack(pathname);

  useEffect(() => {
    getMeta(
      asset.data.url,
      (width, height) => setDimensions((dimensions) => ({ ...dimensions, width, height }))
    );
  }, [ asset.pack_id, asset.data.url ]);

  return (
    <Box as={motion.div} variants={variants} onClick={!canEdit ? (e) => openLink(e, asset) : null}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={asset.data.url}
        alt={asset.data.name}
        width={dimensions.width}
        height={dimensions.height}
      />
    </Box>
  );
};
